var _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltermobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 34,
    viewBox: "0 0 76 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 34,
    rx: 5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 17L10 9",
    stroke: "black",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 25L24 22",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 25L10 21",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 18L24 9",
    stroke: "black",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12L17 9",
    stroke: "black",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 25L17 16",
    stroke: "black",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 19,
    r: 2,
    stroke: "black",
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 14,
    r: 2,
    stroke: "black",
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 20,
    r: 2,
    stroke: "black",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4091 22.5V10.8636H41.3864V12.1136H35.8182V16.0455H40.8636V17.2955H35.8182V22.5H34.4091ZM43.6179 22.5V13.7727H44.9588V22.5H43.6179ZM44.2997 12.3182C44.0384 12.3182 43.813 12.2292 43.6236 12.0511C43.438 11.8731 43.3452 11.6591 43.3452 11.4091C43.3452 11.1591 43.438 10.9451 43.6236 10.767C43.813 10.589 44.0384 10.5 44.2997 10.5C44.5611 10.5 44.7846 10.589 44.9702 10.767C45.1596 10.9451 45.2543 11.1591 45.2543 11.4091C45.2543 11.6591 45.1596 11.8731 44.9702 12.0511C44.7846 12.2292 44.5611 12.3182 44.2997 12.3182ZM48.7557 10.8636V22.5H47.4148V10.8636H48.7557ZM55.0071 13.7727V14.9091H50.4844V13.7727H55.0071ZM51.8026 11.6818H53.1435V20C53.1435 20.3788 53.1984 20.6629 53.3082 20.8523C53.4219 21.0379 53.5658 21.1629 53.7401 21.2273C53.9181 21.2879 54.1056 21.3182 54.3026 21.3182C54.4503 21.3182 54.5715 21.3106 54.6662 21.2955C54.7609 21.2765 54.8366 21.2614 54.8935 21.25L55.1662 22.4545C55.0753 22.4886 54.9484 22.5227 54.7855 22.5568C54.6226 22.5947 54.4162 22.6136 54.1662 22.6136C53.7874 22.6136 53.4162 22.5322 53.0526 22.3693C52.6927 22.2064 52.3935 21.9583 52.1548 21.625C51.92 21.2917 51.8026 20.8712 51.8026 20.3636V11.6818ZM60.5895 22.6818C59.7486 22.6818 59.0232 22.4962 58.4134 22.125C57.8073 21.75 57.3395 21.2273 57.0099 20.5568C56.6842 19.8826 56.5213 19.0985 56.5213 18.2045C56.5213 17.3106 56.6842 16.5227 57.0099 15.8409C57.3395 15.1553 57.7978 14.6212 58.3849 14.2386C58.9759 13.8523 59.6652 13.6591 60.4531 13.6591C60.9077 13.6591 61.3565 13.7348 61.7997 13.8864C62.2429 14.0379 62.6463 14.2841 63.0099 14.625C63.3736 14.9621 63.6634 15.4091 63.8793 15.9659C64.0952 16.5227 64.2031 17.2083 64.2031 18.0227V18.5909H57.4759V17.4318H62.8395C62.8395 16.9394 62.741 16.5 62.544 16.1136C62.3509 15.7273 62.0743 15.4223 61.7145 15.1989C61.3584 14.9754 60.938 14.8636 60.4531 14.8636C59.919 14.8636 59.4569 14.9962 59.0668 15.2614C58.6804 15.5227 58.383 15.8636 58.1747 16.2841C57.9664 16.7045 57.8622 17.1553 57.8622 17.6364V18.4091C57.8622 19.0682 57.9759 19.6269 58.2031 20.0852C58.4342 20.5398 58.7543 20.8864 59.1634 21.125C59.5724 21.3598 60.0478 21.4773 60.5895 21.4773C60.9418 21.4773 61.2599 21.428 61.544 21.3295C61.8319 21.2273 62.08 21.0758 62.2884 20.875C62.4967 20.6705 62.6577 20.4167 62.7713 20.1136L64.0668 20.4773C63.9304 20.9167 63.7012 21.303 63.3793 21.6364C63.0573 21.9659 62.6596 22.2235 62.1861 22.4091C61.7126 22.5909 61.1804 22.6818 60.5895 22.6818ZM66.2429 22.5V13.7727H67.5384V15.0909H67.6293C67.7884 14.6591 68.0762 14.3087 68.4929 14.0398C68.9096 13.7708 69.3793 13.6364 69.902 13.6364C70.0005 13.6364 70.1236 13.6383 70.2713 13.642C70.419 13.6458 70.5308 13.6515 70.6065 13.6591V15.0227C70.5611 15.0114 70.4569 14.9943 70.294 14.9716C70.1349 14.9451 69.9664 14.9318 69.7884 14.9318C69.3641 14.9318 68.9853 15.0208 68.652 15.1989C68.3224 15.3731 68.0611 15.6155 67.8679 15.9261C67.6785 16.233 67.5838 16.5833 67.5838 16.9773V22.5H66.2429Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltermobile);
export default __webpack_public_path__ + "static/media/Filtermobile.aa32153d8fd30aa4ee34eb3c6186a737.svg";
export { ForwardRef as ReactComponent };